module.exports = __webpack_public_path__ + "static/media/background8.117bd97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/background8.png
// module id = 48
// module chunks = 0